export enum DonationInfoFields {
  shouldDonate = 'shouldDonate',
  maxLimit = 'maxLimit',
  collectionSet = 'collectionSet',
  jugularVein = 'jugularVein',
  preferences = 'preferences',
}
